import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  CircularProgress,
  Grid,
  Box,
  Button,
  TextField,
  Card,
  Typography,
  Avatar,
  Drawer,
  useMediaQuery,
  Tooltip,
  IconButton,
  Chip,
  InputAdornment,
} from "@mui/material";
import {
  useGetTaskWithoutDateQuery,
  useGetUserQuery,
  useGetAllHolydaysArrayQuery,
  useGetTaskQuery,
  useCreateTaskMutation,
  useGetCustomerQuery,
  useGetTeamQuery,
  useGetAllTaskSubjectQuery,
  useGetAllPolicyGroupByQuery,
  useGetTaskCategoryQuery,
  useGetAllHolydaysTitleQuery,
} from "../../../Api/attoDeskApi";
import {
  ITasks,
  IUserInfo,
  IPolicy,
  ICustomer,
  ITeam,
  IMeetingCategory2,
} from "../../../Api/Interface/api.interface";
import { Link, useNavigate } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import dayjs, { Dayjs } from "dayjs";
import dayGridPlugin from "@fullcalendar/daygrid";
import FullCalendar from "@fullcalendar/react";
import interactionPlugin, { DateClickArg } from "@fullcalendar/interaction";
import SettingsIcon from "@mui/icons-material/Settings";
import { BiSolidMessageSquareAdd } from "react-icons/bi";
import { styled, useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import GroupIcon from "@mui/icons-material/Group";
import { FaEdit } from "react-icons/fa";
import Autocomplete from "@mui/material/Autocomplete";
import { useFormik } from "formik";
import { useNotifier } from "../../../Core/Notifier";
import { toProperCase } from "../../../Components/Validation/toProperCase";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import TimeDropdown from "../../../Components/CustomTimePicker/TimeDropdown";
import AlertPopUp from "../../../Components/AlertPopUp/AlertPopup";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import TableViewIcon from "@mui/icons-material/TableView";
import * as XLSX from "xlsx";
import { DataGrid, GridColDef, GridRowSelectionModel } from "@mui/x-data-grid";
import { GridRenderCellParams } from "@mui/x-data-grid";
import SearchIcon from "@mui/icons-material/Search";
import { CiSearch } from "react-icons/ci";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";

const capitalizeFirstLetter = (name: string | null | undefined) => {
  if (!name) return "";
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
};

const lightThemeColor = JSON.parse(
  localStorage.getItem("lightThemeColor") || "{}"
);

const setCardBRadius = lightThemeColor?.cardBorderRadius || "none";

const formatTime = (time: string | undefined) => {
  if (!time) return "";
  const [hour, minute] = time.split(":").map(Number);
  const date = new Date();
  date.setHours(hour, minute);
  return new Intl.DateTimeFormat("en-CA", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  }).format(date);
};

interface CustomerOption {
  label: string;
  value: number;
}

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [paymentMonthYear, setPaymentMonthYear] = useState<Dayjs>(dayjs());
  const { data: userData } = useGetUserQuery();
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedId, setSelectedId] = useState<string>("");
  const [selectedMeetingData, setSelectedMeetingData] = useState<ITasks | null>(
    null
  );
  const { showErrorMessage, showMessage } = useNotifier();
  const [selectedCustomerId, setSelectedCustomerId] = useState<string | "">("");
  const prevClientIdRef = useRef<string | "">("");

  const [deleteAlert, setDeleteAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const startDateAsDate = startDate?.toDate() || null;
  const endDateAsDate = endDate?.toDate() || null;

  const [selectedStaffId, setSelectedStaffId] = useState<string | "">("");
  const [selectedClientId, setSelectedClientId] = useState<string | "">("");
  const [selectedCategoryId, setSelectedCategoryId] = useState<string | "">("");

  const [selectedRowIds, setSelectedRowIds] = useState<GridRowSelectionModel>(
    []
  );

  const [searchQuery, setSearchQuery] = useState("");
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");

  const [selectedFinalStatuses, setSelectedFinalStatuses] = useState<string[]>(
    []
  );

  const [newDepartment, { isLoading: meetingSaveIsLoading }] =
    useCreateTaskMutation();

  const userId = React.useMemo(() => {
    if (userData?.data) {
      const userInfo = userData.data as IUserInfo;
      return userInfo.staffId;
    }
    return "";
  }, [userData]);

  const { data, isLoading, isError, refetch } = useGetTaskWithoutDateQuery({
    searchText: currentSearchQuery,
    staffId: selectedStaffId,
    clientId: selectedClientId,
    id: "",
    fromDate: startDateAsDate as Date,
    toDate: endDateAsDate as Date,
    categoryId: selectedCategoryId,
    multi_final_status_filter: selectedFinalStatuses,
  });

  const { data: holydaysData, isLoading: holidaysIsLoading } =
    useGetAllHolydaysArrayQuery({
      searchText: "",
      id: "",
    });

  const { data: holydaysTitleData, isLoading: holidaysTitleIsLoading } =
    useGetAllHolydaysTitleQuery({
      searchText: "",
      id: "",
    });

  const {
    data: meetingData,
    isLoading: meetingLoading,
    error: meetingIsError,
  } = useGetTaskQuery(
    {
      searchText: "",
      staffId: userId || "",
      clientId: "",
      id: selectedId || "",
      meeting_Date: "",
    },
    {
      skip: !selectedId,
    }
  );
  const { data: clientData, isLoading: cilentIsLoading } = useGetCustomerQuery({
    searchText: "",
    id: "",
  });

  const { data: staffData, isLoading: staffIsLoading } = useGetTeamQuery({
    searchText: "",
    id: "",
  });

  const { data: meetingAllData, isLoading: meetingAllIsLoading } =
    useGetAllTaskSubjectQuery({
      searchText: "",
      id: "",
    });

  const {
    data: policyData,
    isLoading: policyIsLoading,
    refetch: policyRefetch,
  } = useGetAllPolicyGroupByQuery({
    searchText: "",
    id: "",
    policyCustomerId: selectedCustomerId,
  });

  const {
    data: getAllMeetingCategoryData,
    isLoading: meetingCategoryIsLoading,
  } = useGetTaskCategoryQuery({
    searchText: "",
  });

  const { data: policyAllData, isLoading: policyAllIsLoading } =
    useGetAllPolicyGroupByQuery({
      searchText: "",
      id: "",
      policyCustomerId: "",
    });

  const fristIndexMeeting = useMemo(() => {
    if (
      meetingData &&
      Array.isArray(meetingData.data) &&
      meetingData.data.length > 0
    ) {
      return meetingData.data[0] as ITasks;
    }
    return null;
  }, [meetingData]);

  const cliendList = useMemo(() => {
    return (clientData?.data ?? []) as ICustomer[];
  }, [clientData?.data]);

  const staffList = useMemo(() => {
    return (staffData?.data ?? []) as ITeam[];
  }, [staffData?.data]);

  const policyList = useMemo(() => {
    return (policyData?.data ?? []) as IPolicy[];
  }, [policyData?.data]);

  const meetingCategoryList = useMemo(() => {
    return (getAllMeetingCategoryData?.data ?? []) as IMeetingCategory2[];
  }, [getAllMeetingCategoryData?.data]);

  const policyAllList = useMemo(() => {
    return (policyAllData?.data ?? []) as IPolicy[];
  }, [policyAllData?.data]);

  const customerOptions = useMemo(() => {
    if (!Array.isArray(cliendList)) return [];
    return cliendList.map((cust) => ({
      label: `${toProperCase(cust.customerFirstName)} ${toProperCase(
        cust.customerLastName
      )}`,
      value: cust.id,
    }));
  }, [cliendList]);

  const staffOptions = useMemo(() => {
    if (!Array.isArray(staffList)) return [];
    return staffList.map((cust) => ({
      label: `${toProperCase(cust.teamFirstName)} ${toProperCase(
        cust.teamLastName
      )}`,
      value: cust.id,
    }));
  }, [staffList]);

  const policyOptions = useMemo(() => {
    if (!Array.isArray(policyList)) return [];
    return policyList.map((cust) => ({
      label: `${cust.policyNumber}`,
      value: cust.id,
    }));
  }, [policyList]);

  const meetingCategoryOptions = useMemo(() => {
    if (!Array.isArray(meetingCategoryList)) return [];
    return meetingCategoryList.map((cust) => ({
      label: `${cust.name}`,
      value: cust.id,
    }));
  }, [meetingCategoryList]);

  const clientMap = useMemo(() => {
    const map = new Map();
    cliendList?.forEach((category) => {
      map.set(
        category.id,
        toProperCase(category.customerFirstName || "") +
          " " +
          toProperCase(category.customerLastName || "")
      );
    });
    return map;
  }, [cliendList]);

  const staffMap = useMemo(() => {
    const map = new Map();
    staffList?.forEach((category) => {
      map.set(
        category.id,
        toProperCase(category.teamFirstName || "") +
          " " +
          toProperCase(category.teamLastName || "")
      );
    });
    return map;
  }, [staffList]);

  const taskCategotyMap = useMemo(() => {
    const map = new Map();
    staffList?.forEach((category) => {
      map.set(
        category.id,
        toProperCase(category.teamFirstName || "") +
          " " +
          toProperCase(category.teamLastName || "")
      );
    });
    return map;
  }, [staffList]);

  const allPolicyMap = useMemo(() => {
    const map = new Map();
    policyAllList?.forEach((category) => {
      map.set(category.id, category.policyNumber);
    });
    return map;
  }, [policyAllList]);

  const finalStatusOptions = [
    { label: "Completed", value: "Completed" },
    { label: "Pending", value: "Pending" },
    { label: "Cancel", value: "Cancel" },
  ];

  useEffect(() => {
    if (debouncedSearchQuery.length >= 2 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  useEffect(() => {
    if (fristIndexMeeting) {
      setSelectedMeetingData(fristIndexMeeting);
    }
  }, [fristIndexMeeting, meetingLoading]);

  const handleStartDateChange = (newValue: Dayjs | null) => {
    setStartDate(newValue);
  };

  const handleEndDateChange = (newValue: Dayjs | null) => {
    setEndDate(newValue);
  };

  if (isLoading || holidaysIsLoading || holidaysTitleIsLoading)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );

  const coursings: ITasks[] = Array.isArray(data?.data)
    ? (data?.data as ITasks[])
    : [];

  const handleAddProductClick = () => {
    navigate(
      `/client/task/create?date=${paymentMonthYear.format("YYYY-MM-DD")}`
    );
  };

  const handleSettingClick = () => {
    navigate(`/client/task/setting`);
  };

  const handleEditClose = () => {
    setOpenDrawer(false);
    setSelectedId("");
    setSelectedMeetingData(null);
  };

  const viewMeetingProfile = () => {
    navigate(`/task/profile/${selectedMeetingData?.id}`);
  };

  const resetFields = () => {
    setStartDate(null);
    setEndDate(null);
    setSelectedStaffId("");
    setSelectedClientId("");
    setSelectedCategoryId("");
    setCurrentSearchQuery("");
    setSearchQuery("");
    setSelectedFinalStatuses([]);
  };

  const columns: GridColDef[] = [
    {
      field: "endDateOnly",
      headerName: "End Date",
      minWidth: 100,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        return params.value ? dayjs(params.value).format("MMM D, YYYY") : "";
      },
    },
    {
      field: "clientId",
      headerName: "General/General",
      minWidth: 220,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => (
        <Link
          to={`/profile/customer/${params.row.policyCustomerIdInitial}`}
          className={classes.iconLinkPropNormal}
        >
          <span
            style={{
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            {params.value}
            {params.value && (
              <FontAwesomeIcon icon={faUser} style={{ color: "#1976d2" }} />
            )}
          </span>
        </Link>
      ),
    },
    {
      field: "subject",
      headerName: "Subject",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "staffId",
      headerName: "To",
      minWidth: 220,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => (
        <Link
          to={`/team-history/${params.row.policyStaffIdInitial}`}
          className={classes.iconLinkPropNormal}
        >
          <span
            style={{
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            {params.value}
            {params.value && (
              <FontAwesomeIcon icon={faUser} style={{ color: "#1976d2" }} />
            )}
          </span>
        </Link>
      ),
    },
    {
      field: "finalStatus",
      headerName: "Status",
      minWidth: 180,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        const value = (params.value as string)?.toLowerCase();
      
        let bgColor: string = "#9e9e9e"; // default gray
        let label: string = "Pending"; // default label
      
        switch (value) {
          case "completed":
            bgColor = "#2e7d32"; // green
            label = "Completed";
            break;
          case "pending":
            bgColor = "#1976d2"; // blue
            label = "Pending";
            break;
          case "cancel":
            bgColor = "#d32f2f"; // red
            label = "Cancel";
            break;
          default:
            bgColor = "#1976d2";
            label = "Pending";
        }
      
        return (
          <Chip
            label={label}
            variant="outlined"
            size="small"
            sx={{
              fontWeight: 400,
              backgroundColor: bgColor,
              color: "#fff",
              borderColor: bgColor,
              py: 1,
              px: 1,
            }}
          />
        );
      },
      
    },
    {
      field: "endDateTime",
      headerName: "Completed",
      minWidth: 200,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        return params.value
          ? dayjs(params.value).format("MMM D, YYYY h:mm A")
          : "";
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      minWidth: 100,
      flex: 1,
      headerClassName: classes.tablheader200,
      headerAlign: "right",
      renderCell: (params: GridRenderCellParams) => (
        <Grid
          container
          spacing={1}
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <Grid item>
            <Link
              to={`/task/profile/${params.row.id}`}
              className={classes.iconLinkPropNormal}
            >
              <IconButton
                className={classes.viewButtonListGridTable}
                onClick={() => navigate(`/task/profile/${params.row.id}`)}
              >
                <SearchIcon className={classes.viewListIcon} />
              </IconButton>
            </Link>
          </Grid>
        </Grid>
      ),
    },
  ];

  const formattedRows = coursings.map((row) => ({
    id: row.id,
    subject: row.subject,
    staffId: staffMap.get(Number(row.staffId)) || "",
    clientId: clientMap.get(Number(row.clientId)) || "",
    categoryId: taskCategotyMap.get(Number(row.categoryId)) || "",
    // start_Date: row.start_Date,
    endDateOnly: row.end_Date,
    finalStatus: row.final_status,
    policyCustomerIdInitial: row.clientId,
    policyStaffIdInitial: row.staffId,
    bgColor: row.meeting_category_color || "#ffffff", // fallback color
    style: {
      "--row-bg-color": row.meeting_category_color || "#ffffff",
    } as React.CSSProperties,
  }));

  const handleRowSelection = (selectionModel: GridRowSelectionModel) => {
    setSelectedRowIds(selectionModel);
  };

  if (
    isLoading ||
    holidaysIsLoading ||
    cilentIsLoading ||
    staffIsLoading ||
    meetingAllIsLoading ||
    meetingCategoryIsLoading ||
    policyAllIsLoading
  )
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );

  return (
    <div>
      <Card className={classes.card}>
        <Grid container spacing={3}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid
              container
              justifyContent={"space-between"}
              spacing={5}
              sx={{ padding: 2, borderBottom: 2 }}
              className={classes.titleGrid}
            >
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Grid
                  container
                  spacing={1}
                  justifyContent="flex-end"
                  sx={{ display: "flex" }}
                >
                  <Grid item>
                    <Link
                      to={`/client/task/create?date=${paymentMonthYear.format(
                        "YYYY-MM-DD"
                      )}`}
                      className={classes.iconLinkPropNormal}
                    >
                      <Button
                        startIcon={<BiSolidMessageSquareAdd />}
                        className={classes.addNewButton}
                        onClick={handleAddProductClick}
                      >
                        Add New
                      </Button>
                    </Link>
                  </Grid>
                  <Grid item>
                    <Link
                      to={`/client/task/setting`}
                      className={classes.iconLinkPropNormal}
                    >
                      <Button
                        startIcon={<SettingsIcon />}
                        className={classes.addNewButton}
                        onClick={handleSettingClick}
                      >
                        Setting
                      </Button>
                    </Link>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={3} my={5} p={4}>
              <Grid item lg={2.4} md={4} sm={12} xs={12}>
                <Grid container>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Typography variant="subtitle1" className={classes.body2}>
                      Staff
                    </Typography>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Autocomplete
                      options={staffOptions}
                      loading={staffIsLoading}
                      value={
                        staffOptions.find(
                          (option) => String(option.value) === selectedStaffId
                        ) || null
                      }
                      getOptionLabel={(option: CustomerOption) => option.label}
                      onChange={(event, newValue: CustomerOption | null) => {
                        setSelectedStaffId(String(newValue?.value ?? ""));
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          InputLabelProps={{ shrink: true }}
                          placeholder="Staff .."
                        />
                      )}
                      sx={{ flexGrow: 1, width: "100%" }}
                      size="small"
                      className={classes.searchTextField}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={2.4} md={4} sm={12} xs={12}>
                <Grid container>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Typography variant="subtitle1" className={classes.body2}>
                      Client
                    </Typography>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Autocomplete
                      options={customerOptions}
                      loading={cilentIsLoading}
                      value={
                        customerOptions.find(
                          (option) => String(option.value) === selectedClientId
                        ) || null
                      }
                      getOptionLabel={(option: CustomerOption) => option.label}
                      onChange={(event, newValue: CustomerOption | null) => {
                        setSelectedClientId(String(newValue?.value ?? ""));
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          InputLabelProps={{ shrink: true }}
                          placeholder="Client .."
                        />
                      )}
                      sx={{ flexGrow: 1, width: "100%" }}
                      size="small"
                      className={classes.searchTextField}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={2.4} md={4} sm={12} xs={12}>
                <Grid container>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Typography variant="subtitle1" className={classes.body2}>
                      Category
                    </Typography>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Autocomplete
                      options={meetingCategoryOptions}
                      loading={meetingCategoryIsLoading}
                      value={
                        meetingCategoryOptions.find(
                          (option) =>
                            String(option.value) === selectedCategoryId
                        ) || null
                      }
                      getOptionLabel={(option: CustomerOption) => option.label}
                      onChange={(event, newValue: CustomerOption | null) => {
                        setSelectedCategoryId(String(newValue?.value ?? ""));
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          InputLabelProps={{ shrink: true }}
                          placeholder="Category .."
                        />
                      )}
                      sx={{ flexGrow: 1, width: "100%" }}
                      size="small"
                      className={classes.searchTextField}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={2.4} md={4} sm={12} xs={12}>
                <Grid container>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Typography variant="subtitle1" className={classes.body2}>
                      From Date
                    </Typography>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        onChange={handleStartDateChange}
                        value={startDate}
                        slotProps={{
                          textField: {
                            size: "small",
                            sx: { width: "100%" },
                            InputProps: {
                              sx: { fontSize: 14 },
                            },
                            InputLabelProps: {
                              sx: { fontSize: 14 },
                            },
                          },
                        }}
                        className={classes.searchTextField}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={2.4} md={4} sm={12} xs={12}>
                <Grid container>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Typography variant="subtitle1" className={classes.body2}>
                      To Date
                    </Typography>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        onChange={handleEndDateChange}
                        value={endDate}
                        slotProps={{
                          textField: {
                            size: "small",
                            sx: { width: "100%" },
                            InputProps: {
                              sx: { fontSize: 14 },
                            },
                            InputLabelProps: {
                              sx: { fontSize: 14 },
                            },
                          },
                        }}
                        className={classes.searchTextField}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={4.8} md={12} sm={12} xs={12}>
                <Grid container>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Typography variant="subtitle1" className={classes.body2}>
                      Search Subject
                    </Typography>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <TextField
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <CiSearch className={classes.searchWidgetIcon} />
                          </InputAdornment>
                        ),
                        classes: {
                          root: classes.formControlList,
                        },
                      }}
                      fullWidth
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      placeholder="Subject .."
                      sx={{ width: "100%" }}
                      size="small"
                      className={classes.searchTextField}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={4.8} md={12} sm={12} xs={12}>
                <Grid container>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Typography variant="subtitle1" className={classes.body2}>
                       Status
                    </Typography>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Autocomplete
                      multiple
                      options={finalStatusOptions}
                      value={finalStatusOptions.filter((option) =>
                        selectedFinalStatuses.includes(option.value)
                      )}
                      getOptionLabel={(option) => option.label}
                      onChange={(event, newValue) => {
                        setSelectedFinalStatuses(
                          newValue.map((item) => item.value)
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          InputLabelProps={{ shrink: true }}
                          placeholder="Select Status..."
                        />
                      )}
                      sx={{ flexGrow: 1, width: "100%" }}
                      size="small"
                      className={classes.searchTextField}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Box display="flex" justifyContent="flex-end">
                  <Button
                    variant="outlined"
                    startIcon={<RestartAltIcon />}
                    className={classes.addButton}
                    onClick={resetFields}
                  >
                    Reset
                  </Button>
                </Box>
              </Grid>
            </Grid>
            <Grid>
              <Grid container spacing={2}>
                <Grid
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  sx={{ width: "100%", pb: 5, borderTop: 2, pl: 1 }}
                  className={classes.titleGrid}
                >
                  <DataGrid
                    rows={formattedRows}
                    columns={columns}
                    getRowId={(row) => row.id}
                    autoHeight
                    pagination
                    initialState={{
                      pagination: { paginationModel: { pageSize: 100 } },
                    }}
                    pageSizeOptions={[5, 10, 20, 50, 100]}
                    style={{ height: "100%", width: "100%" }}
                    className={classes.dataGridTable}
                    rowHeight={60}
                    checkboxSelection
                    disableRowSelectionOnClick
                    onRowSelectionModelChange={handleRowSelection}
                    getRowClassName={(params) =>
                      params.row.bgColor ? `row-bg-${params.row.id}` : ""
                    }
                  />

                  {/* Inject dynamic row background colors */}
                  <style>
                    {formattedRows
                      .map(
                        (row) => `
                            .row-bg-${row.id} {
                            background-color: ${row.bgColor || "#ffffff"};
                          }
                        `
                      )
                      .join("\n")}
                  </style>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Card>
    </div>
  );
};

export default Index;
